import { BrandDateFormat } from "../../../models/brand.model.ts";
import { httpRequest } from "../../http";

/** The date formats a brand can prefer (MPN-2071), in display order. The same for every organization. */
export class CommandListBrandDateFormats {
    async run(): Promise<BrandDateFormat[]> {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/brand-date-formats/`;
        return await httpRequest<BrandDateFormat[]>(url, { method: "GET" });
    }
}
